export const SELECTED_KEYS = {
  none: 'none',
  i_rated_good: 'i_rated_good',
  i_rated_bad: 'i_rated_bad',
  others_rated_good: 'others_rated_good',
  others_rated_bad: 'others_rated_bad',
};
